// Hand-written UI dictionary for Masakan Kekinian.
// Display-only: values that reach routes or the Spoonacular API (such as
// meal-type values like "main course") always stay in English and are
// never passed through this dictionary; only their labels are looked up
// here under `mealTypes`, keyed by the English value.
// Recipe data from the API (titles, ingredients, steps) is not translated.
const translations = {
  en: {
    nav: {
      home: "Home",
      recipes: "Recipes",
      about: "About",
    },
    hero: {
      tagline: "Your Best Cooking Companion",
      searchPlaceholder: "What are you craving today?",
      searchLabel: "Search",
    },
    mealType: {
      heading: "Find Your Type of Meal",
      more: "More",
      less: "Less",
    },
    mealTypes: {
      "main course": "Main Course",
      "side dish": "Side Dish",
      dessert: "Dessert",
      appetizer: "Appetizer",
      salad: "Salad",
      bread: "Bread",
      breakfast: "Breakfast",
      soup: "Soup",
      beverage: "Beverage",
      sauce: "Sauce",
      marinade: "Marinade",
      fingerfood: "Fingerfood",
      snack: "Snack",
      drink: "Drink",
    },
    popular: {
      heading: "Popular Food Recipe",
      empty: "No recipes found.",
    },
    common: {
      prev: "Prev",
      next: "Next",
      loadError: "Failed to load recipes. Please try again later.",
      recipeNotFound: "Recipe not found.",
      backToHome: "Back to Home",
      loadingAlt: "loading",
    },
    sidebar: {
      searchPlaceholder: "Find Recipes",
      mealTypeHeading: "Meal Type",
      all: "All",
    },
    foodCard: {
      minutes: "min",
    },
    recipe: {
      ingredients: "Ingredients",
      cookingTime: "Cooking Time",
      minutes: "minutes",
      servings: "Servings",
      cookingProcess: "Cooking Process",
      notFoundText:
        "This recipe could not be loaded. It may not exist, or the service is temporarily unavailable. Please try again later.",
    },
    notFound: {
      title: "Page Not Found",
      text: "The page you are looking for does not exist or has been moved.",
    },
    errorBoundary: {
      title: "Something went wrong.",
      text: "The page failed to load. Please try again later.",
    },
    about: {
      title: "About Masakan Kekinian",
      p1: 'Masakan Kekinian ("Trending Recipes") is a recipe discovery website for everyday cooking ideas as well as dishes for special occasions. There is no account and no cost: open the site, search or pick a type of meal, and the recipe appears.',
      p2: "Search recipes by keyword, browse by type of meal (main course, dessert, breakfast, soup, and more), or explore the popular recipes on the homepage. Every recipe page shows a large photo, a summary with nutrition highlights and a Spoonacular score, the full ingredients list, cooking time, servings, and step-by-step cooking instructions.",
      p3: "All recipe data, images, and scores come live from the Spoonacular API, fetched fresh when a page opens. Recipes are never stored on this site; every page load, search, and detail view is served directly from the Spoonacular catalog.",
      p4: "Masakan Kekinian is made in Jakarta, Indonesia, for home cooks looking for their next meal idea.",
    },
  },
  id: {
    nav: {
      home: "Beranda",
      recipes: "Resep",
      about: "Tentang",
    },
    hero: {
      tagline: "Teman Memasak Terbaikmu",
      searchPlaceholder: "Mau makan apa hari ini?",
      searchLabel: "Cari",
    },
    mealType: {
      heading: "Temukan Jenis Makananmu",
      more: "Lainnya",
      less: "Tutup",
    },
    mealTypes: {
      "main course": "Hidangan Utama",
      "side dish": "Hidangan Pendamping",
      dessert: "Hidangan Penutup",
      appetizer: "Hidangan Pembuka",
      salad: "Salad",
      bread: "Roti",
      breakfast: "Sarapan",
      soup: "Sup",
      beverage: "Minuman",
      sauce: "Saus",
      marinade: "Bumbu Rendaman",
      fingerfood: "Camilan",
      snack: "Camilan",
      drink: "Minuman Segar",
    },
    popular: {
      heading: "Resep Makanan Populer",
      empty: "Resep tidak ditemukan.",
    },
    common: {
      prev: "Sebelumnya",
      next: "Berikutnya",
      loadError: "Gagal memuat resep. Silakan coba lagi nanti.",
      recipeNotFound: "Resep tidak ditemukan.",
      backToHome: "Kembali ke Beranda",
      loadingAlt: "memuat",
    },
    sidebar: {
      searchPlaceholder: "Cari Resep",
      mealTypeHeading: "Jenis Makanan",
      all: "Semua",
    },
    foodCard: {
      minutes: "mnt",
    },
    recipe: {
      ingredients: "Bahan-bahan",
      cookingTime: "Waktu Memasak",
      minutes: "menit",
      servings: "Porsi",
      cookingProcess: "Cara Memasak",
      notFoundText:
        "Resep ini tidak dapat dimuat. Resep mungkin tidak ada, atau layanan sedang tidak tersedia. Silakan coba lagi nanti.",
    },
    notFound: {
      title: "Halaman Tidak Ditemukan",
      text: "Halaman yang kamu cari tidak ada atau sudah dipindahkan.",
    },
    errorBoundary: {
      title: "Terjadi kesalahan.",
      text: "Halaman gagal dimuat. Silakan coba lagi nanti.",
    },
    about: {
      title: "Tentang Masakan Kekinian",
      p1: "Masakan Kekinian adalah situs pencarian resep untuk ide memasak sehari-hari maupun hidangan istimewa untuk acara khusus. Tanpa akun, tanpa biaya: cukup buka situsnya, cari atau pilih jenis makanannya, dan resepnya langsung tampil.",
      p2: "Cari resep berdasarkan kata kunci, jelajahi menurut jenis makanan (hidangan utama, hidangan penutup, sarapan, sup, dan lainnya), atau temukan resep populer di halaman utama. Setiap halaman resep menampilkan foto besar, ringkasan dengan sorotan nutrisi dan skor Spoonacular, daftar bahan lengkap, waktu memasak, jumlah porsi, dan petunjuk memasak langkah demi langkah.",
      p3: "Semua data resep, gambar, dan skor berasal langsung dari API Spoonacular dan diambil saat halaman dibuka. Resep tidak pernah disimpan di situs ini; setiap kunjungan, pencarian, dan tampilan detail disajikan langsung dari katalog Spoonacular.",
      p4: "Masakan Kekinian dibuat di Jakarta, Indonesia, untuk para juru masak rumahan yang mencari ide makanan berikutnya.",
    },
  },
};

export default translations;
